<!--
    *传进来的值自己要做非空处理，组件内部不做处理，数字类型的空值传0；字符串类型的值组件接受什么就展示什么
-->

<template>
  <span
    class="circleBox"
    :class="circleClass ? circleClass : ''"
    :style="{
      width: `${$vw(cx * 2 + strokeWidth)}`,
      height: `${$vw(cx * 2 + strokeWidth)}`,
    }"
  >
    <svg
      :width="cx * 2"
      :height="cx * 2"
      :viewbox="viewbox"
      v-if="renderSvgArr && renderSvgArr.length > 0"
    >
      <circle
        v-for="(item, index) in renderSvgArr"
        :key="index"
        :class="item != `0 ${svgGirth}` ? `${item.strokeClass}` : ''"
        :cx="cx"
        :cy="cy"
        :r="r"
        :stroke-width="strokeWidth"
        fill="none"
        :transform="`matrix(0,-1,1,0,0,${cx * 2})`"
        :stroke-dasharray="item.data"
      ></circle>
    </svg>
    <span class="svgTip singleRow" v-if="typeof centerText == 'string'">
      <span class="svgTip_bigFont" v-text="centerText"></span>
    </span>
    <span
      class="svgTip towRow"
      v-if="typeof centerText == 'object' && centerText.length == 2"
    >
      <span class="svgTip_bigFont" v-text="centerText[0]"></span>
      <span
        class="svgTip_smallFont"
        :style="{ width: svgTipSamllWidth }"
        v-text="centerText[1]"
      ></span>
    </span>
  </span>
</template>

<script>
export default {
  props: {
    centerText: {
      type: [String, Array],
      default: '',
    },
    svgDataArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    perCeil: {
      type: Number,
      default: 100,
    },
    cxy: {
      type: Number,
      default: 0.106,
    },
    strokeWidth: {
      type: Number,
      default: 10,
    },
    circleClass: {
      type: String,
      default: '',
    },
    svgTipSamllWidth: {
      type: String,
      default: 'auto',
    },
  },
  data() {
    return {
      cx: 0,
      cy: 0,
      // strokeWidth: 10,
      //   svgDataArr: [],
      // svgDataArr: [
      //   {
      //     val: 40,
      //     perVal: 40,
      //     strokeClass: 'svg_color0',
      //     key: "home", //1
      //   },
      //   {
      //     val: 60,
      //     perVal: 60,
      //     strokeClass: 'svg_color1',
      //     key: "away", //2
      //   },
      // ],
      keyArr: ['name', 'val'],
    }
  },
  created() {
    // this.cx = this.cxy[0];
    // this.cy = this.cxy[1];
    this.onResizeEvent()
    window.addEventListener('resize', this.onResizeEvent)
  },
  beforeRouteLeave() {
    window.removeEventListener('resize', this.onResizeEvent)
  },
  computed: {
    r() {
      // 圆半径
      return this.cy - this.strokeWidth / 2 - 1
    },
    svgGirth() {
      // 圆周长
      return Math.floor(Math.PI * 2 * this.r)
    },
    viewbox() {
      // svg自带参数
      return `0 0 ${this.cx * 2} ${this.cx * 2}`
    },
    renderSvgArr() {
      //倒序的，第一个线段在最后一个，最后一个在第一个
      if (!this.svgDataArr) {
        return [`0 ${this.svgGirth}`, `0 ${this.svgGirth}`]
      }
      let total = 0

      let newSvgDataArr = [] //只对有值的指标项进行计算和渲染，0或者不存在的值过滤掉
      this.svgDataArr.forEach((item) => {
        item.renderVal = item[this.keyArr[1]] - 0
        if (this.svgDataArr.length >= 2) {
          if (item.renderVal || item.renderVal === 0) {
            newSvgDataArr.push(item)
          }
        } else {
          if (item.renderVal) {
            newSvgDataArr.push(item)
          }
        }

        total += item.renderVal //这个值是用来计算圆环百分比的值，区别于源数据中的item[this.keyArr[1]]，因为item[this.keyArr[1]]还需要展示在其他地方，所以不能动
      })
      // console.debug(`total: ${total}`);
      // console.debug(`newSvgDataArr:`);
      // console.debug(newSvgDataArr);
      // console.debug(`svgDataArr:`);
      // console.debug(this.svgDataArr);
      if (!total) {
        // 如果总是为0，需将圆环平分，但是展示值是0
        return [
          {
            data: this.svgGirth,
            perValText: 0,
            strokeClass: 'svg_color_notData',
          },
          {
            data: this.svgGirth,
            perValText: 0,
            strokeClass: 'svg_color_notData',
          },
        ]
      }
      console.debug('11newSvgDataArr:', newSvgDataArr)
      if (newSvgDataArr.length > 2) {
        // 这种支持多种颜色的圆环，0~n多可以，但需要补齐颜色
        let reduceSvgVal = 0
        return newSvgDataArr.map((cell, cIndex) => {
          let svgVal1 = Math.round((cell.perVal / this.perCeil) * this.svgGirth)
          let svgVal2 = this.svgGirth - svgVal1 - reduceSvgVal
          if (svgVal2 < 0) {
            svgVal1 = svgVal1 + svgVal2
            svgVal2 = 0
          }
          reduceSvgVal += svgVal1
          console.debug('reduceSvgVal:', reduceSvgVal)
          if (cIndex === 0) {
            return {
              data: `${svgVal1} ${svgVal2}`,
              perValText: cell.perVal * 100 + '%',
              strokeClass: cell.strokeClass,
            }
          } else {
            return {
              data: `0 ${reduceSvgVal - svgVal1} ${svgVal1} ${svgVal2}`,
              perValText: cell.perVal * 100 + '%',
              strokeClass: svgVal1 ? cell.strokeClass : 'svg_color_transparent',
            }
          }
        })
      } else {
        let singleValFlag = false
        let homeSvgVal = 0
        if (newSvgDataArr.length == 1) {
          singleValFlag = true
          homeSvgVal = Math.floor(
            (this.svgDataArr[0].perVal / this.perCeil) * this.svgGirth
          )
          console.debug('homeSvgVal:', homeSvgVal)
        } else {
          homeSvgVal = Math.floor(
            (newSvgDataArr[0].renderVal / total) * this.svgGirth
          )
        }

        let awaySvgVal = this.svgGirth - homeSvgVal
        console.debug('newSvgDataArr:', newSvgDataArr, homeSvgVal, awaySvgVal)
        if (homeSvgVal === 0 && awaySvgVal != homeSvgVal) {
          return [
            {
              data: `${awaySvgVal} ${homeSvgVal} `,
              perValText: newSvgDataArr[1].perVal * 100 + '%',
              strokeClass: newSvgDataArr[1].perVal
                ? newSvgDataArr[1].strokeClass
                : 'svg_color_notData',
            },
          ]
        }
        if (awaySvgVal === 0 && awaySvgVal != homeSvgVal) {
          return [
            {
              data: `${homeSvgVal} ${awaySvgVal}`,
              perValText: newSvgDataArr[0].perVal * 100 + '%',
              strokeClass: newSvgDataArr[0].perVal
                ? newSvgDataArr[0].strokeClass
                : 'svg_color_notData',
            },
          ]
        }
        return [
          {
            data: `${homeSvgVal} ${awaySvgVal}`,
            perValText: newSvgDataArr[0].perVal * 100 + '%',
            strokeClass: newSvgDataArr[0].perVal
              ? newSvgDataArr[0].strokeClass
              : 'svg_color_notData',
          },
          {
            data: `0 ${homeSvgVal} ${awaySvgVal}`,
            perValText: singleValFlag ? 0 : newSvgDataArr[1].perVal * 100 + '%',
            strokeClass: singleValFlag
              ? 'svg_color_notData'
              : newSvgDataArr[1].perVal
              ? newSvgDataArr[1].strokeClass
              : 'svg_color_notData',
          },
        ]
      }
    },
  },
  methods: {
    onResizeEvent() {
      const clientWidth = window.innerWidth || window.screen.width
      let r = Math.floor(clientWidth * this.cxy)
      console.debug('rrr:', r)
      this.cx = this.cy = r
    },
  },
}
</script>

<style lang="scss" scoped>
@import './vw.scss';

.circleBox {
  position: relative;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  /* padding: 0 vw(5); */
  &.pLR0 {
    padding: 0;
  }
  svg {
    circle {
      -webkit-transition: stroke-dasharray 0.5s;
      transition: stroke-dasharray 0.5s;
    }
  }
  .svg_color_transparent {
    stroke: transparent;
  }
  .svg_color_notData {
    stroke: rgba(255, 255, 255, 0.12);
  }
  .svg_color0 {
    stroke: rgba(205, 8, 70, 1);
  }
  .svg_color1 {
    stroke: rgba(0, 207, 183, 1);
  }
  .svg_color2 {
    stroke: rgba(63, 141, 229, 1);
  }
  .svgTip {
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: absolute;
    top: 50%;
    left: 0;
    z-index: 2;
    width: 100%;
    transform: translateY(-50%);
    .svgTip_bigFont {
      text-align: center;
      font-size: vw(16);
      line-height: 1;
      color: #fff;
      font-weight: bold;
    }
    .svgTip_smallFont {
      padding-top: vw(4);
      text-align: center;
      font-size: vw(10);
      line-height: vw(12);
      color: rgba(255, 255, 255, 0.85);
    }
  }
}
</style>
